export default "__VITE_ASSET__BLgdYG_T__"